interface TeachMarkProps {
  /** Rendered height in px (width scales with the aspect ratio). */
  size?: number;
  /** Color of the "T" pillars. Defaults to the brand charcoal. */
  color?: string;
  /** Accessible label; omit for decorative use. */
  title?: string;
}

/**
 * Teach by DosFilos isotype — the "T / pulpit" whose negative space forms the
 * two-edged sword, with the gem above. The pillars take `color` (default
 * charcoal), the gem the brand teal. Source: teach-isotipo SVG.
 */
export function TeachMark({ size = 32, color = '#121d1e', title }: TeachMarkProps) {
  return (
    <svg
      viewBox="-7 10 614 636"
      height={size}
      width={(size * 614) / 636}
      fill="none"
      role={title ? 'img' : 'presentation'}
      {...(title ? { 'aria-label': title } : { 'aria-hidden': true })}
    >
      <path
        d="M33 182 L280 182 L280 584 L254 606 L254 226 C254 212 242 200 228 200 L47 200 Z"
        fill={color}
      />
      <path
        d="M567 182 L320 182 L320 584 L346 606 L346 226 C346 212 358 200 372 200 L553 200 Z"
        fill={color}
      />
      <path d="M300 50 L330 95 L300 140 L270 95 Z" fill="#0d9488" />
    </svg>
  );
}
